export default {
  Mentions: 'Mentions',
  BrandHealth: 'Brand Health',
};
